<template>
  <a-modal width="45%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>费率信息</b>
    </a-divider>
    <a-table :data-source="rateTypeList" rowKey="feeRateTypeCode" :columns="skuColumns" :pagination="false" bordered>
      <span slot="feeRatePct" slot-scope="text, record">
         <a-input-number v-model="record.feeRatePct"
                         style="width: 80%"
                         :min="0" :max="100" :step="0.01"
                         placeholder="费率"  />
                <span>%</span>
      </span>
      <span slot="feeUpperAmtPcnt" slot-scope="text, record">
         <a-input-number v-model="record.feeUpperAmtPcnt"
                         style="width: 80%"
                         :min="0" :max="100" :step="0.01"
                         placeholder="单笔手续费封顶"  />
                <span>元</span>
      </span>
      <span slot="feeLowerAmtPcnt" slot-scope="text, record">
         <a-input-number v-model="record.feeLowerAmtPcnt"
                         style="width: 80%"
                         :min="0" :max="100" :step="0.01"
                         placeholder="单笔手续费保低"  />
                <span>元</span>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      rateTypeList:[
      ],
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      errorMessage:undefined,
      skuColumns: [
        {
          title: '费率类型',
          dataIndex: 'feeRateTypeName',
          key: 'feeRateTypeName',
        },
        {
          title: '手续费率(%)',
          dataIndex: 'feeRatePct',
          key: 'feeRatePct',
          scopedSlots: {customRender: 'feeRatePct'}
        },
        {
          title: '单笔手续费封顶',
          dataIndex: 'feeUpperAmtPcnt',
          key: 'feeUpperAmtPcnt',
          scopedSlots: {customRender: 'feeUpperAmtPcnt'}
        },
        {
          title: '单笔手续费保低',
          dataIndex: 'feeLowerAmtPcnt',
          key: 'feeLowerAmtPcnt',
          scopedSlots: {customRender: 'feeLowerAmtPcnt'}
        },
      ],
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.resetRateType()
    },
    resetRateType() {
      this.rateTypeList = []
      this.customDict.MerchantRateTypeEnum.forEach(item => {
        const newData = {
          feeRateTypeCode: item.type,
          feeRateTypeName: item.name,
          feeRatePct: 0,
          feeUpperAmtPcnt: 0,
          feeLowerAmtPcnt: 0,
        };
        this.rateTypeList.push(newData)
      })
    },
    /** 修改按钮操作 */
    show(rateTypeList) {
      if (rateTypeList && rateTypeList.length > 0) {
        this.rateTypeList = rateTypeList;
      } else {
        this.resetRateType()
      }
      this.open = true
    },
    onOk() {
      //判断有没有选择,拿到列表里选择的
      this.open = false
      this.$emit('rateType', this.rateTypeList)
      this.reset()
    },
  }
}
</script>
